export default "__VITE_ASSET__WN7QVboc__"